import { useContext, useEffect, useReducer, useState } from "react";
import { Loading, Modelos } from "./Modelos";
import { MensajeContActualizacion } from "../Context/MensajeContextActualizacion";
import { tokens } from "../Context/Tokens";
import { Post2 } from "../Rutas/ApiRest";
import { cuentaCliente } from "../Rutas/Servicios";

function BorrarCuenta()
{

    const [state,dispatch]=useReducer(reducer,{Nombre:"",casilla:"",Correo:"",observacion:""})
    const [Select,SetSelect]=useState("Seleccione")
    const {SetMensajeEmergente,SetLoading}=useContext(MensajeContActualizacion)
    const {tok,toggleTodo}=useContext(tokens)

    useEffect(()=>
        {
            toggleTodo()
        },[])
    const enviar=()=>
        {
           if(validador())
            {
                var body={

                    "Nombre": state.Nombre,
                    "Ecode":state.casilla,
                    "observacion":state.observacion,
                    "Motivo":Select
                }
                const datos=Post2(cuentaCliente.CierreCuenta,JSON.stringify(body),"application/json",tok)
                datos.then(resultado=>{SetMensajeEmergente(resultado);SetLoading(false)})
            }
            
        }

        const validador=()=>
            {
                if(state.Nombre=="")
                {
                    SetMensajeEmergente("Debe agregar su nombre")
                    SetLoading(false)
                    return false;
                }
                if(Select=="Seleccione")
                {
                    SetMensajeEmergente("Debe seleccionar el motivo del cierre de cuenta")
                    SetLoading(false)
                    return false;
                }
                if(state.casilla=="")
                {
                    SetMensajeEmergente("Ingrese una casilla valida")
                    SetLoading(false)
                    return false;
                }
                if(state.Correo=="")
                {
                    SetMensajeEmergente("Debe ingresar su correo")
                    SetLoading(false)
                    return false;
                }


                return true;    
            }

        function reducer(state:any,action:any)
        {
          switch(action.type)
          {
            case "cambio":return {
              ...state,[action.input.name]:action.input.value
            }
            case "Reinicio":return{Nombre:"",casilla:"",Correo:"",observacion:""}
    
          }
        
          return state;
        }
        function cambio(event:any)
        {
          dispatch({type:"cambio",input:{
            name:event.target.name,
            value:event.target.value
          }})
    
    
          
        }

        const SelectOption=(event:any)=>
            {
                SetSelect(event.target.value)
            }

    return (<>
   
   <div className="container py-5">
  <div className="row">
    <div className="col-12 col-sm-5 px-5 px-sm-5 offset-sm-1">
      <img src="https://apps.eshopex.cl/images/app-eshopex.png" width="100" height="auto" alt="eShopex" className="pb-3"/><h4>App Eshopex Chile</h4>
      <p style={{padding:"0",marginBottom:"20px"}}>Para eliminar los datos de tu cuenta, debes completar el formulario con la información correspondiente.</p>
      <p style={{padding:"0",marginBottom:"20px"}}>Luego de eso debes confirmar la eliminación y el proceso estará finalizado.</p>
      <p style={{padding:"0",marginBottom:"20px"}}>El tiempo estimado para que la eliminación de la cuenta sea efectiva es de 24 horas hábiles</p>
      <p style={{padding:"0",marginBottom:"20px"}}>Los datos personales del cliente serán eliminados, no así, los datos del historial de carga que quedarán en nuestros registros por un periodo de 6 meses.</p>
    </div>
    <div className="col-12 col-sm-6 px-5 px-sm-0">
      
      <h4>Borrar cuenta eShopex</h4>
      <p style={{padding:"0",marginTop:"10px",display:"inline-block"}}>Para eliminar tu cuenta, debes completar los datos del formulario que encontrarás más abajo.</p>
    
        <div className="form-group">
          <label style={{padding:"0",marginTop:"10px"}}>Nombre (*)</label>
          <input style={{width:"70% !important"}} type="text" name="Nombre" id="Nombre" value={state.Nombre} onChange={cambio} className="form-control" />


        </div>
        <div className="form-group">
          <label style={{padding:"0",marginTop:"20px",display:"inline-block"}}>Casilla eShopex (*)</label>
          <input type="text" id="casilla" name="casilla" value={state.casilla} onChange={cambio} className="form-control"/>
        </div>
        <div className="form-group">
          <label style={{padding:"0",marginTop:"20px",display:"inline-block"}}>Correo de Contacto (*)</label>
          <input type="text" id="Correo" name="Correo" value={state.Correo} onChange={cambio} className="form-control" />
        </div>
        <div className="form-group">
          <label style={{padding:"0",marginTop:"20px",display:"inline-block"}}>Motivo de la eliminación (*)</label>
          <select id="MotivoLst" name="MotivoLst" onChange={SelectOption} className="form-select" style={{width:"70% !important"}}>
            <option value="0">Seleccione</option>
            <option value="1">Mala atención</option>
            <option value="2">No lo uso</option>
            <option value="3">No sé usar la página</option>
            <option value="4">Cobros muy altos</option>
            <option value="5">Problemas con despacho</option>
            <option value="6">Otro</option>
          </select>
        </div>
        
		  <div className="form-group">
    <label style={{padding:"0",marginTop:"20px",display:"inline-block"}}>Observaciones</label>
    <textarea id="observacion" name="observacion" value={state.observacion} onChange={cambio} className="form-control"  ></textarea>
  
          </div>  
       
        <button className="btn btn-primary mt-2"  id="BtnEnviar" onClick={()=>{SetLoading(true); enviar()}}>Enviar</button> 
     
    </div>
  </div>
</div>
<Modelos></Modelos>
<Loading></Loading>
  </>

    )
}

export default BorrarCuenta;